<article class="faculty-sub-domain-container">
  <div class="faculty-sub-domain">
    <app-faculties-details-side-menu
      class="side-menu"
      [selectedFaculty]="faculty!"
    ></app-faculties-details-side-menu>

    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
